import React from "react";
import DropShadow from "../DropShadow/DropShadow";
import WindowControls from "../WindowControls/WindowControls";
export default function Window() {
  return (
    <>
      <p className="font-semibold text-gray-800 flex items-center text-lg">
        <span className="text-xl ri-window-fill font-medium "></span>&nbsp;
        Window Settings
      </p>
      <WindowControls />
    
      <DropShadow />
    </>
  );
}
